<!-- DEPARTMENT DETAIL -->
<template>
  <CRow>
    <CCol sm="5" lg="4">
      <CCard>
        <CCardHeader><b>Department Info</b></CCardHeader>
        <CListGroup>
          <CListGroupItem href="#">
            Department Name : {{ response.data.name }}
          </CListGroupItem>
          <CListGroupItem class="d-flex justify-content-between" href="#">
            Head of Department : {{ head.firstname + " " + head.lastname }}
            <CButton
              variant="outline"
              color="danger"
              size="sm"
              v-if="head.id"
              @click="remove_head(response.data.id, head.id)"
            >
              Remove as Leader
            </CButton>
          </CListGroupItem>
        </CListGroup>
      </CCard>
      <CCard>
        <CCardHeader><b>Core Team</b></CCardHeader>
        <CListGroup>
          <CListGroupItem href="#" v-for="item in data_filter" :key="item.id">
            <div>
              <CRow>
                <CCol>
                  {{ item.member.firstname + " " + item.member.lastname }}
                </CCol>
                <CCol>
                  <CButton
                    class="ml-4"
                    variant="outline"
                    color="danger"
                    size="sm"
                    @click="
                      remove_core_team(response.data.id, item.member.uuid)
                    "
                    >Remove as Core Team</CButton
                  >
                </CCol>
              </CRow>
            </div>
          </CListGroupItem>
        </CListGroup>
      </CCard>
      <CCard>
        <CCardHeader><b>Background Image</b></CCardHeader>
        <CListGroup>
          <CListGroupItem>
            <div>
              <CRow>
                <CCol>
                  <img
                    v-bind:src="response.data.image"
                    width="200"
                    height="150"
                  />
                  <CButton
                    class="ml-4"
                    variant="outline"
                    color="success"
                    @click="openModalPhoto(response.data.id)"
                    >Change Image</CButton
                  >
                </CCol>
              </CRow>
            </div>
          </CListGroupItem>
        </CListGroup>
      </CCard>
    </CCol>
    <CCol sm="5" lg="8">
      <CCard>
        <CCardHeader><b>Description Department</b></CCardHeader>

        <CListGroupItem href="#">
          Description : {{ response.data.description }}
        </CListGroupItem>
      </CCard>
      <CCard>
        <CCardHeader><b>Department Member</b></CCardHeader>
        <CListGroup
          v-for="item in response.data.department_member"
          :key="item.id"
        >
          <CListGroupItem href="#">
            <CRow>
              <CCol @click="show_member(item.member_id)">
                <img
                  class="c-avatar-img mr-4 mt-2"
                  v-bind:src="getPhoto(item.member.get_photo)"
                />{{ item.member.firstname + " " + item.member.lastname }}

                <CBadge color="primary" v-if="item.member_id == head.id">
                  <b> LEADER </b>
                </CBadge>
                <CBadge
                  color="primary"
                  v-if="item.is_core_team == '1' && item.member_id != head.id"
                  ><b>CORE TEAM</b></CBadge
                >
                <br />
              </CCol>
              <CCol class="col-4">
                <CButton
                  variant="outline"
                  color="info"
                  block
                  size="sm"
                  v-if="item.is_core_team == '0' && item.member_id != head.id"
                  @click="assign_core_team(response.data.id, item.member.uuid)"
                  >Assign as Core Team</CButton
                >
                <CButton
                  class="mt-2"
                  variant="outline"
                  color="success"
                  block
                  size="sm"
                  v-if="!head.id && item.is_core_team == '0'"
                  @click="assign_head(response.data.id, item.member.uuid)"
                  >Assign As Leader</CButton
                >
                <CButton
                  class="mt-2"
                  variant="outline"
                  color="danger"
                  block
                  size="sm"
                  @click="remove_member(response.data.id, item.member_id)"
                  >Remove as Member</CButton
                >
              </CCol>
            </CRow>
          </CListGroupItem>
        </CListGroup>
      </CCard>
    </CCol>
    <alertmodal></alertmodal>
    <modalphotobg></modalphotobg>
  </CRow>
</template>

<script>
import _ from "lodash";
import axios from "axios";

import EventBus from "@/eventBus";
import alertmodal from "@/views/alert/modal.vue";
import store from "@/store.js";

import modalphotobg from "./modal_photo_bgimage.vue";
import department from "@/services/department";

export default {
  name: "departmentdetail",
  components: { alertmodal, modalphotobg },
  data() {
    return {
      mode: "",
      response: [],
      form: {
        id: "",
      },
      head: {
        id: "",
        firstname: "",
        lastname: "",
        get_photo: [],
      },
      temp: {},
    };
  },
  mounted() {
    this.load();
    EventBus.$on("TABLE_UPDATE", (data) => {
      if (data) {
        this.load();
      }
    });
  },
  computed: {
    data_filter: function() {
      return _.pickBy(this.response.data.department_member, function(u) {
        return u.is_core_team == "1";
      });
    },
  },
  methods: {
    load() {
      var self = this;
      department.getDepartmentDetails(this.$route.query.Pud).then((res) => {
        this.response = res;
        this.head.id = res.data.head != null ? res.data.head.uuid : "";
        this.head.firstname =
          res.data.head != null ? res.data.head.firstname : "";
        this.head.lastname =
          res.data.head != null ? res.data.head.lastname : "";
        this.head.get_photo =
          res.data.head != null ? res.data.head.get_photo : "";
        this.head.get_photo =
          res.data.head != null ? res.data.head.get_photo : "";
      });
    },
    getPhoto(data) {
      if (data) {
        return (
          axios.defaults.baseURL + "/getfile/" + data.path + "/" + data.filename
        );
      } else {
        return axios.defaults.baseURL + "/getfile/memberphoto/no_photo.jpg";
      }
    },
    show_member: function(uuid) {
      //muncul detail at same page, tetapi saat back hanya url nya yg kerubah.
      // this.$router.push({path: '/member/member_detail',query: {Pud:uuid} })
      // window.location.reload()

      //new tab
      let routeData = this.$router.resolve({
        path: "/member/member_detail",
        query: { Pud: uuid },
      });
      window.open(routeData.href, "_blank");
    },
    assign_head(id, member_id) {
      let Permission = store.state.user.authenticated.permission;
      if (typeof Permission != "undefined") {
        if (
          Permission.indexOf(
            "Create/edit department (including assign HOD/assign member to core teams/etc)"
          ) !== -1
        ) {
          //IF ALLOW
          if (confirm("Do you really want to assign as leader?")) {
            var param = {
              member_id: member_id,
            };
            department
              .assign_head_of_Department(id, param)
              .then((res) => {
                this.load();
                var params = {
                  title: "Success",
                  mode: "success",
                  data: res.message,
                };
                EventBus.$emit("OPEN_MODAL_ALERT", params);
              })
              .catch((err) => {
                var params = {
                  title: "Error",
                  mode: "danger",
                  data: err.response.data.message,
                };
                EventBus.$emit("OPEN_MODAL_ALERT", params);
              });
            //END ALLOW
          }
        } else {
          //IF NOT
          var params = {
            title: "Error",
            mode: "danger",
            data: "unautenticated",
          };
          EventBus.$emit("OPEN_MODAL_ALERT", params);
        }
        //SET END
      }
    },
    remove_head(id, member_id) {
      let Permission = store.state.user.authenticated.permission;
      if (typeof Permission != "undefined") {
        if (
          Permission.indexOf(
            "Create/edit department (including assign HOD/assign member to core teams/etc)"
          ) !== -1
        ) {
          //IF ALLOW
          if (confirm("Do you really want to remove as leader?")) {
            var param = {
              member_id: member_id,
            };
            department
              .remove_head_of_Department(id, param)
              .then((res) => {
                this.load();
                var params = {
                  title: "Success",
                  mode: "success",
                  data: res.message,
                };
                EventBus.$emit("OPEN_MODAL_ALERT", params);
              })
              .catch((err) => {
                var params = {
                  title: "Error",
                  mode: "danger",
                  data: err.response.data.message,
                };
                EventBus.$emit("OPEN_MODAL_ALERT", params);
              });
          }
          //END ALLOW
        }
      } else {
        //IF NOT
        var params = { title: "Error", mode: "danger", data: "unautenticated" };
        EventBus.$emit("OPEN_MODAL_ALERT", params);
      }
      //SET END
    },
    assign_core_team(id, member_id) {
      let Permission = store.state.user.authenticated.permission;
      if (typeof Permission != "undefined") {
        if (
          Permission.indexOf(
            "Create/edit department (including assign HOD/assign member to core teams/etc)"
          ) !== -1
        ) {
          //IF ALLOW
          if (confirm("Do you really want to assign as core team?")) {
            var param = {
              member_id: member_id,
            };
            department
              .assign_core_team_Department(id, param)
              .then((res) => {
                this.load();
                var params = {
                  title: "Success",
                  mode: "success",
                  data: res.message,
                };
                EventBus.$emit("OPEN_MODAL_ALERT", params);
              })
              .catch((err) => {
                var params = {
                  title: "Error",
                  mode: "danger",
                  data: err.response.data.message,
                };
                EventBus.$emit("OPEN_MODAL_ALERT", params);
              });
            //END ALLOW
          }
        } else {
          //IF NOT
          var params = {
            title: "Error",
            mode: "danger",
            data: "unautenticated",
          };
          EventBus.$emit("OPEN_MODAL_ALERT", params);
        }
        //SET END
      }
    },
    remove_core_team(id, member_id) {
      let Permission = store.state.user.authenticated.permission;
      if (typeof Permission != "undefined") {
        if (
          Permission.indexOf(
            "Create/edit department (including assign HOD/assign member to core teams/etc)"
          ) !== -1
        ) {
          //IF ALLOW
          if (confirm("Do you really want to remove as core team?")) {
            var param = {
              member_id: member_id,
            };
            department
              .remove_core_team_Department(id, param)
              .then((res) => {
                this.load();
                var params = {
                  title: "Success",
                  mode: "success",
                  data: res.message,
                };
                EventBus.$emit("OPEN_MODAL_ALERT", params);
              })
              .catch((err) => {
                var params = {
                  title: "Error",
                  mode: "danger",
                  data: err.response.data.message,
                };
                EventBus.$emit("OPEN_MODAL_ALERT", params);
              });
          }
          //END ALLOW
        }
      } else {
        //IF NOT
        var params = { title: "Error", mode: "danger", data: "unautenticated" };
        EventBus.$emit("OPEN_MODAL_ALERT", params);
      }
      //SET END
    },
    remove_member(id, member_id) {
      let Permission = store.state.user.authenticated.permission;
      if (typeof Permission != "undefined") {
        if (
          Permission.indexOf(
            "Create/edit department (including assign HOD/assign member to core teams/etc)"
          ) !== -1
        ) {
          //IF ALLOW
          if (confirm("Do you really want to remove as member?")) {
            var param = {
              member_id: member_id,
            };
            department
              .remove_member_Department(id, param)
              .then((res) => {
                this.load();
                var params = {
                  title: "Success",
                  mode: "success",
                  data: res.message,
                };
                EventBus.$emit("OPEN_MODAL_ALERT", params);
              })
              .catch((err) => {
                var params = {
                  title: "Error",
                  mode: "danger",
                  data: err.response.data.message,
                };
                EventBus.$emit("OPEN_MODAL_ALERT", params);
              });
          }
          //END ALLOW
        }
      } else {
        //IF NOT
        var params = { title: "Error", mode: "danger", data: "unautenticated" };
        EventBus.$emit("OPEN_MODAL_ALERT", params);
      }
      //SET END
    },
    openShowPhoto(url) {
      window.open(url, "_blank", "height=800,width=1000");
    },

    openModalPhoto(id) {
      var params = { title: "Department Image", mode: "edit", data: id };
      EventBus.$emit("OPEN_MODAL_DEPARTMENT_PHOTO", params);
      console.log("load modal photo");
    },
  },
};
</script>
